<div>
    <ng-container>
        <h2 class="title" style="margin-bottom: 5px;">Menu Label</h2>
    </ng-container>

    <div class="menu_toggle_main_div">
        <div [ngClass]="{'active_btn': selectedToggle == 'add'}" (click)="maenuLabelToggle('add')">ADD</div>
        <div [ngClass]="{'active_btn': selectedToggle == 'modify'}" (click)="maenuLabelToggle('modify')">MODIFY</div>
    </div>
    <ng-container *ngIf="selectedToggle == 'add'">
        <div class="menu_label_body">
            <div class="menu_label_body_sub_div" *ngIf="!isExistingDish">
                <label for="exiting_menu_name" class="fnt-wght">Enter label for exiting dishes</label>
                <input id="exiting_menu_name" type="text" class="form-control custom-inp"
                    [(ngModel)]="existingDishLabel" />
            </div>

            <div class="menu_label_body_sub_div">
                <label for="exiting_menu_name" class="fnt-wght">Enter label for new dishes</label>
                <input id="exiting_menu_name" type="text" class="form-control custom-inp" [(ngModel)]="newDishLabel" />
            </div>

        </div>

        <div class="form-check">
            <input class="form-check-input" type="checkbox" value="" id="checkDefault" [(ngModel)]="hideLabel">
            <label class="form-check-label" for="checkDefault">
                Hide this label
            </label>
        </div>

        <ng-container>
            <div class="btn-main-div">
                <button tc-button [type]="'button'" [view]="'error'" (click)="close()">Close</button>
                <button tc-button [type]="'button'" [view]="'success'" (click)="addLabels()">Add Label</button>
            </div>
        </ng-container>
    </ng-container>

    <ng-container *ngIf="selectedToggle == 'modify'">
        <div style="width: 392px;">
            <div *ngIf="allMenuName.length == 0; else menuLabelList">
                <div class="no_menu_found">NO MENU LABEL FOUND</div>
            </div>
            <ng-template #menuLabelList>
                <div style="max-height: 40vh; overflow: auto;">
                    <div *ngFor="let item of allMenuName; let i = index" class="menu_labels_list">
                        <div class="menu_labels_name">
                            <div *ngIf="!item.isEdit">{{i+1}}. &nbsp;</div>
                            <div *ngIf="!item.isEdit">{{item.dish_menu_name}}</div>
                            <input type="text" *ngIf="item.isEdit" [(ngModel)]="item.dish_menu_name"
                                class="form-control" />
                        </div>

                        <div style="display: flex; align-items: center; gap: 5px;">
                            <div class="form-check form-switch">
                                <input class="form-check-input" style="height:20px; width:3em; cursor:pointer;"
                                    type="checkbox" [id]="'checkNativeSwitch_' + i"
                                    [ngModel]="item.dish_menu_status === 'Active'"
                                    (ngModelChange)="onStatusToggle(item, $event)" />
                            </div>

                            &nbsp;

                            <button tc-button [afterIcon]="'icofont-ui-edit'" [view]="'info'" [tcFontSize]="10"
                                [square]="true" [tcShape]="500" [size]="'sm'" (click)="item.isEdit = true"
                                *ngIf="!item.isEdit"></button>

                            <button tc-button [afterIcon]="'icofont-tick-mark'" [view]="'success'" [tcFontSize]="10"
                                [square]="true" [tcShape]="500" [size]="'sm'" (click)="updateMenuLabelName(item)"
                                *ngIf="item.isEdit"></button>
                            &nbsp;
                            <button tc-button [afterIcon]="'icofont-ui-delete'" [tcFontSize]="10" [view]="'error'"
                                [square]="true" [tcShape]="500" [size]="'sm'" (click)="deleteMenuLabel(item)"></button>
                        </div>
                    </div>
                </div>
            </ng-template>

            <div class="actions" style="text-align: center;">
                <button tc-button [type]="'button'" [view]="'error'" (click)="close()">Close</button>
            </div>

        </div>


        <div class="delete_confirm_dialog" *ngIf="deleteFlag">
            <div style="font-weight: 500;text-align: justify;">Are you sure? Deleting this label will remove all linked
                dishes.</div>
            <div class="fotter_btn">
                <button tc-button [type]="'button'" [view]="'success'" (click)="cancelDelete()">Cancel</button>
                <button tc-button [type]="'button'" [view]="'error'" (click)="deleteLabel()">Delete</button>
            </div>
        </div>
    </ng-container>


</div>





<style>
    .title {
        font-family: 'Roboto';
        font-size: 18px;
        line-height: 40px;
        font-weight: 500;
        color: #394046;

    }

    .menu_label_body {
        display: flex;
        flex-direction: column;
        gap: 20px;
    }

    .menu_label_body_sub_div {
        display: grid;
        grid-template-columns: 1fr 1fr;
        align-items: center;
    }


    .fnt-wght {
        font-weight: 500;
    }


    .custom-inp {
        border-radius: 22px;
        padding: 17px;
        background: #ebebeb;
    }

    .custom-inp:focus {
        /* background-color: white !important; */
        background: rgba(51, 108, 251, 0.01) !important;
        border-color: #336cfb !important;
        box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.12) !important;
    }


    .btn-main-div {
        display: flex;
        justify-content: center;
        gap: 40px;
        margin-top: 25px;
    }

    .menu_toggle_main_div {
        display: grid;
        grid-template-columns: 1fr 1fr;
        align-items: center;
        justify-content: center;
        margin-bottom: 15px;

    }

    .menu_toggle_main_div div {
        text-align: center;
        cursor: pointer;
    }

    .menu_toggle_main_div .active_btn {
        border-bottom: 2px solid rgb(3, 95, 3);
    }

    .menu_labels_list {
        display: grid;
        grid-template-columns: 3fr 1fr;
        margin-bottom: 10px;
        align-items: center;
        gap: 32px;
    }

    .menu_labels_name {
        /* font-size: 16px; */
        font-weight: 500;
        display: flex;
        align-items: center;
        gap: 2px;
    }

    .no_menu_found {
        margin-bottom: 35px;
        text-align: center;
        margin-top: 19px;
        font-size: 19px;
        font-weight: 500;
    }

    .delete_confirm_dialog {
        position: absolute;
        top: 0;
        bottom: 0;
        margin: auto;
        background: #eddddd;
        height: 108px;
        width: 274px;
        padding: 10px;
        box-shadow: 0px 3px 10px #0D0D0D4B;
        border-radius: 10px;
        left: 0;
        right: 0;
    }

    .delete_confirm_dialog .fotter_btn {
        margin-top: 10px;
        display: flex;
        justify-content: space-around;
        margin-bottom: 10px;
    }
</style>